module.exports = __webpack_public_path__ + "static/media/ilustration-trash.d8cbc512.svg";